module.exports = __webpack_public_path__ + "img/1-1-p4.ced2beb0.svg";